//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import dayjs from 'dayjs';

export class ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "/api/_int";
    }

    /**
     * Create an accident case
     * @param body (optional) 
     * @return Case created successfully
     */
    accidentCasesPost(body: CreateAccidentCaseRequest | undefined): Promise<CreateCaseResponse> {
        let url_ = this.baseUrl + "/accident-cases";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccidentCasesPost(_response);
        });
    }

    protected processAccidentCasesPost(response: Response): Promise<CreateCaseResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateCaseResponse;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Validation failed \u2014 returns structured error list", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Unexpected server error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCaseResponse>(null as any);
    }

    /**
     * Get an accident case by id
     * @return Accident case body
     */
    accidentCasesGet(id: string): Promise<AccidentCaseResponse> {
        let url_ = this.baseUrl + "/accident-cases/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccidentCasesGet(_response);
        });
    }

    protected processAccidentCasesGet(response: Response): Promise<AccidentCaseResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccidentCaseResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Case not found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccidentCaseResponse>(null as any);
    }

    /**
     * Update an accident case
     * @param body (optional) 
     * @return Case updated successfully
     */
    accidentCasesPut(id: string, body: UpdateAccidentCaseRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/accident-cases/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccidentCasesPut(_response);
        });
    }

    protected processAccidentCasesPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Validation failed", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Case not found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Convert an accident case to a damage case
     * @return Converted successfully
     */
    accidentCasesConvert(id: string): Promise<ConvertCaseResponse> {
        let url_ = this.baseUrl + "/accident-cases/{id}/convert";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccidentCasesConvert(_response);
        });
    }

    protected processAccidentCasesConvert(response: Response): Promise<ConvertCaseResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConvertCaseResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Case not found", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Case is closed and cannot be converted", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConvertCaseResponse>(null as any);
    }

    /**
     * Export an accident case as PDF
     * @param scope (optional) 
     * @param timeZone (optional) 
     * @return PDF file
     */
    accidentCasesExport(id: string, scope: ExportScope | undefined, lang: string, timeZone: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/accident-cases/{id}/export?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (scope === null)
            throw new globalThis.Error("The parameter 'scope' cannot be null.");
        else if (scope !== undefined)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        if (lang === undefined || lang === null)
            throw new globalThis.Error("The parameter 'lang' must be defined and cannot be null.");
        else
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (timeZone === null)
            throw new globalThis.Error("The parameter 'timeZone' cannot be null.");
        else if (timeZone !== undefined)
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccidentCasesExport(_response);
        });
    }

    protected processAccidentCasesExport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Invalid request parameters", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Case not found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Upload an accident case sketch
     * @param file (optional) 
     * @return Sketch uploaded
     */
    accidentCaseSketchesPost(file: FileParameter | undefined): Promise<UploadDamageSketchResponse> {
        let url_ = this.baseUrl + "/accident-case-sketches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccidentCaseSketchesPost(_response);
        });
    }

    protected processAccidentCaseSketchesPost(response: Response): Promise<UploadDamageSketchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UploadDamageSketchResponse;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Validation failed (FileNameMismatch, EmptyFile, HeicConversionFailed)", status, _responseText, _headers);
            });
        } else if (status === 413) {
            return response.text().then((_responseText) => {
            return throwException("Request exceeds the upload size limit", status, _responseText, _headers);
            });
        } else if (status === 415) {
            return response.text().then((_responseText) => {
            return throwException("File type not supported", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UploadDamageSketchResponse>(null as any);
    }

    /**
     * Get metadata for accident case sketches by ids
     * @param ids (optional) 
     * @return Metadata list
     */
    accidentCaseSketchesGet(ids: string[] | undefined): Promise<AttachmentMetadataResponse[]> {
        let url_ = this.baseUrl + "/accident-case-sketches?";
        if (ids === null)
            throw new globalThis.Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccidentCaseSketchesGet(_response);
        });
    }

    protected processAccidentCaseSketchesGet(response: Response): Promise<AttachmentMetadataResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AttachmentMetadataResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentMetadataResponse[]>(null as any);
    }

    /**
     * Download accident case sketch content
     * @return Success
     */
    accidentCaseSketchesContent(id: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/accident-case-sketches/{id}/content";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccidentCaseSketchesContent(_response);
        });
    }

    protected processAccidentCaseSketchesContent(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Delete an accident case sketch
     * @return Sketch deleted
     */
    accidentCaseSketchesDelete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/accident-case-sketches/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccidentCaseSketchesDelete(_response);
        });
    }

    protected processAccidentCaseSketchesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Sketch not found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Start workflow for an accident case
     * @return Workflow started
     */
    accidentCasesWorkflowStartWorkflow(caseId: string): Promise<void> {
        let url_ = this.baseUrl + "/accident-cases/{caseId}/workflow/start-workflow";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccidentCasesWorkflowStartWorkflow(_response);
        });
    }

    protected processAccidentCasesWorkflowStartWorkflow(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Case not found", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Case is Closed \u2014 cannot start workflow", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Close an accident case
     * @return Case closed
     */
    accidentCasesWorkflowCloseCase(caseId: string): Promise<void> {
        let url_ = this.baseUrl + "/accident-cases/{caseId}/workflow/close-case";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccidentCasesWorkflowCloseCase(_response);
        });
    }

    protected processAccidentCasesWorkflowCloseCase(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Case not found", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Case is not InProgress", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Reopen an accident case
     * @return Case reopened
     */
    accidentCasesWorkflowReopenCase(caseId: string): Promise<void> {
        let url_ = this.baseUrl + "/accident-cases/{caseId}/workflow/reopen-case";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccidentCasesWorkflowReopenCase(_response);
        });
    }

    protected processAccidentCasesWorkflowReopenCase(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Case not found", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Case is not Closed", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get workflow data for an accident case
     * @return Workflow data
     */
    accidentCasesWorkflowGet(caseId: string): Promise<WorkflowResponse> {
        let url_ = this.baseUrl + "/accident-cases/{caseId}/workflow";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccidentCasesWorkflowGet(_response);
        });
    }

    protected processAccidentCasesWorkflowGet(response: Response): Promise<WorkflowResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkflowResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Case not found or workflow not started", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkflowResponse>(null as any);
    }

    /**
     * Save workflow fields and the persisted document set for an accident case
     * @param body (optional) 
     * @return Saved
     */
    accidentCasesWorkflowPut(caseId: string, body: UpdateWorkflowRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/accident-cases/{caseId}/workflow";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccidentCasesWorkflowPut(_response);
        });
    }

    protected processAccidentCasesWorkflowPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Invalid document ids", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Case or workflow not found", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Case is not InProgress", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Upload a workflow document for an accident case
     * @param file (optional) 
     * @return Document uploaded
     */
    accidentCasesWorkflowDocumentsPost(caseId: string, file: FileParameter | undefined): Promise<WorkflowDocumentRef> {
        let url_ = this.baseUrl + "/accident-cases/{caseId}/workflow/documents";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccidentCasesWorkflowDocumentsPost(_response);
        });
    }

    protected processAccidentCasesWorkflowDocumentsPost(response: Response): Promise<WorkflowDocumentRef> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkflowDocumentRef;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("HEIC/HEIF conversion failed", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Case not found or workflow not started", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Case is not InProgress", status, _responseText, _headers);
            });
        } else if (status === 413) {
            return response.text().then((_responseText) => {
            return throwException("Request exceeds the upload size limit", status, _responseText, _headers);
            });
        } else if (status === 415) {
            return response.text().then((_responseText) => {
            return throwException("Unsupported file type", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkflowDocumentRef>(null as any);
    }

    /**
     * Delete a workflow document from an accident case
     * @return Deleted
     */
    accidentCasesWorkflowDocumentsDelete(caseId: string, documentId: string): Promise<void> {
        let url_ = this.baseUrl + "/accident-cases/{caseId}/workflow/documents/{documentId}";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccidentCasesWorkflowDocumentsDelete(_response);
        });
    }

    protected processAccidentCasesWorkflowDocumentsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Case not found or workflow not started", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Case is not InProgress", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Download workflow document content
     * @return Success
     */
    accidentCasesWorkflowDocumentsContent(caseId: string, documentId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/accident-cases/{caseId}/workflow/documents/{documentId}/content";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAccidentCasesWorkflowDocumentsContent(_response);
        });
    }

    protected processAccidentCasesWorkflowDocumentsContent(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get cases list
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param caseNumber (optional) 
     * @param type (optional) 
     * @param licensePlate (optional) 
     * @param embossedId (optional) 
     * @param location (optional) 
     * @param driver (optional) 
     * @param status (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Cases list
     */
    cases(dateFrom: dayjs.Dayjs | undefined, dateTo: dayjs.Dayjs | undefined, caseNumber: string | undefined, type: CaseType | undefined, licensePlate: string | undefined, embossedId: string | undefined, location: string | undefined, driver: string | undefined, status: CaseStatus | undefined, sortBy: string | undefined, sortDirection: string | undefined, page: number | undefined, pageSize: number | undefined): Promise<CaseListResponse> {
        let url_ = this.baseUrl + "/cases?";
        if (dateFrom === null)
            throw new globalThis.Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateTo === null)
            throw new globalThis.Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toISOString() : "") + "&";
        if (caseNumber === null)
            throw new globalThis.Error("The parameter 'caseNumber' cannot be null.");
        else if (caseNumber !== undefined)
            url_ += "caseNumber=" + encodeURIComponent("" + caseNumber) + "&";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (licensePlate === null)
            throw new globalThis.Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (embossedId === null)
            throw new globalThis.Error("The parameter 'embossedId' cannot be null.");
        else if (embossedId !== undefined)
            url_ += "embossedId=" + encodeURIComponent("" + embossedId) + "&";
        if (location === null)
            throw new globalThis.Error("The parameter 'location' cannot be null.");
        else if (location !== undefined)
            url_ += "location=" + encodeURIComponent("" + location) + "&";
        if (driver === null)
            throw new globalThis.Error("The parameter 'driver' cannot be null.");
        else if (driver !== undefined)
            url_ += "driver=" + encodeURIComponent("" + driver) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCases(_response);
        });
    }

    protected processCases(response: Response): Promise<CaseListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseListResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseListResponse>(null as any);
    }

    /**
     * Get case meta by id
     * @return Case meta
     */
    casesMeta(id: string): Promise<CaseMetaResponse> {
        let url_ = this.baseUrl + "/cases/meta/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCasesMeta(_response);
        });
    }

    protected processCasesMeta(response: Response): Promise<CaseMetaResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseMetaResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Case not found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseMetaResponse>(null as any);
    }

    /**
     * Get a case submission by id
     * @return Submission found
     */
    caseSubmissions(id: string): Promise<CaseSubmissionResponse> {
        let url_ = this.baseUrl + "/case-submissions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCaseSubmissions(_response);
        });
    }

    protected processCaseSubmissions(response: Response): Promise<CaseSubmissionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseSubmissionResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Submission not found", status, _responseText, _headers);
            });
        } else if (status === 410) {
            return response.text().then((_responseText) => {
            let result410: any = null;
            result410 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CaseSubmissionExpiredResponse;
            return throwException("Submission link has expired", status, _responseText, _headers, result410);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CaseSubmissionResponse>(null as any);
    }

    /**
     * Create a damage case
     * @param body (optional) 
     * @return Case created successfully
     */
    damageCasesPost(body: CreateDamageCaseRequest | undefined): Promise<CreateCaseResponse> {
        let url_ = this.baseUrl + "/damage-cases";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDamageCasesPost(_response);
        });
    }

    protected processDamageCasesPost(response: Response): Promise<CreateCaseResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateCaseResponse;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Validation failed \u2014 returns structured error list", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Unexpected server error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCaseResponse>(null as any);
    }

    /**
     * Get a damage case by id
     * @return Damage case body
     */
    damageCasesGet(id: string): Promise<DamageCaseResponse> {
        let url_ = this.baseUrl + "/damage-cases/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDamageCasesGet(_response);
        });
    }

    protected processDamageCasesGet(response: Response): Promise<DamageCaseResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DamageCaseResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Case not found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DamageCaseResponse>(null as any);
    }

    /**
     * Update a damage case
     * @param body (optional) 
     * @return Case updated successfully
     */
    damageCasesPut(id: string, body: UpdateDamageCaseRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/damage-cases/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDamageCasesPut(_response);
        });
    }

    protected processDamageCasesPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Validation failed", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Case not found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Convert a damage case to an accident case
     * @return Converted successfully
     */
    damageCasesConvert(id: string): Promise<ConvertCaseResponse> {
        let url_ = this.baseUrl + "/damage-cases/{id}/convert";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDamageCasesConvert(_response);
        });
    }

    protected processDamageCasesConvert(response: Response): Promise<ConvertCaseResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConvertCaseResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Case not found", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Case is closed and cannot be converted", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConvertCaseResponse>(null as any);
    }

    /**
     * Export a damage case as PDF
     * @param scope (optional) 
     * @param timeZone (optional) 
     * @return PDF file
     */
    damageCasesExport(id: string, scope: ExportScope | undefined, lang: string, timeZone: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/damage-cases/{id}/export?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (scope === null)
            throw new globalThis.Error("The parameter 'scope' cannot be null.");
        else if (scope !== undefined)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        if (lang === undefined || lang === null)
            throw new globalThis.Error("The parameter 'lang' must be defined and cannot be null.");
        else
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (timeZone === null)
            throw new globalThis.Error("The parameter 'timeZone' cannot be null.");
        else if (timeZone !== undefined)
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDamageCasesExport(_response);
        });
    }

    protected processDamageCasesExport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Invalid request parameters", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Case not found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Upload a damage case sketch
     * @param file (optional) 
     * @return Sketch uploaded
     */
    damageCaseSketchesPost(file: FileParameter | undefined): Promise<UploadDamageSketchResponse> {
        let url_ = this.baseUrl + "/damage-case-sketches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDamageCaseSketchesPost(_response);
        });
    }

    protected processDamageCaseSketchesPost(response: Response): Promise<UploadDamageSketchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UploadDamageSketchResponse;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Validation failed (FileNameMismatch, EmptyFile, HeicConversionFailed)", status, _responseText, _headers);
            });
        } else if (status === 413) {
            return response.text().then((_responseText) => {
            return throwException("Request exceeds the upload size limit", status, _responseText, _headers);
            });
        } else if (status === 415) {
            return response.text().then((_responseText) => {
            return throwException("File type not supported", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UploadDamageSketchResponse>(null as any);
    }

    /**
     * Get metadata for damage case sketches by ids
     * @param ids (optional) 
     * @return Metadata list
     */
    damageCaseSketchesGet(ids: string[] | undefined): Promise<AttachmentMetadataResponse[]> {
        let url_ = this.baseUrl + "/damage-case-sketches?";
        if (ids === null)
            throw new globalThis.Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDamageCaseSketchesGet(_response);
        });
    }

    protected processDamageCaseSketchesGet(response: Response): Promise<AttachmentMetadataResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AttachmentMetadataResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentMetadataResponse[]>(null as any);
    }

    /**
     * Download damage case sketch content
     * @return Success
     */
    damageCaseSketchesContent(id: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/damage-case-sketches/{id}/content";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDamageCaseSketchesContent(_response);
        });
    }

    protected processDamageCaseSketchesContent(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Delete a damage case sketch
     * @return Sketch deleted
     */
    damageCaseSketchesDelete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/damage-case-sketches/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDamageCaseSketchesDelete(_response);
        });
    }

    protected processDamageCaseSketchesDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Sketch not found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Start workflow for a damage case
     * @return Workflow started
     */
    damageCasesWorkflowStartWorkflow(caseId: string): Promise<void> {
        let url_ = this.baseUrl + "/damage-cases/{caseId}/workflow/start-workflow";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDamageCasesWorkflowStartWorkflow(_response);
        });
    }

    protected processDamageCasesWorkflowStartWorkflow(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Case not found", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Case is Closed \u2014 cannot start workflow", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Close a damage case
     * @return Case closed
     */
    damageCasesWorkflowCloseCase(caseId: string): Promise<void> {
        let url_ = this.baseUrl + "/damage-cases/{caseId}/workflow/close-case";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDamageCasesWorkflowCloseCase(_response);
        });
    }

    protected processDamageCasesWorkflowCloseCase(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Case not found", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Case is not InProgress", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Reopen a damage case
     * @return Case reopened
     */
    damageCasesWorkflowReopenCase(caseId: string): Promise<void> {
        let url_ = this.baseUrl + "/damage-cases/{caseId}/workflow/reopen-case";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDamageCasesWorkflowReopenCase(_response);
        });
    }

    protected processDamageCasesWorkflowReopenCase(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Case not found", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Case is not Closed", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get workflow data for a damage case
     * @return Workflow data
     */
    damageCasesWorkflowGet(caseId: string): Promise<WorkflowResponse> {
        let url_ = this.baseUrl + "/damage-cases/{caseId}/workflow";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDamageCasesWorkflowGet(_response);
        });
    }

    protected processDamageCasesWorkflowGet(response: Response): Promise<WorkflowResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkflowResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Case not found or workflow not started", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkflowResponse>(null as any);
    }

    /**
     * Save workflow fields and the persisted document set for a damage case
     * @param body (optional) 
     * @return Saved
     */
    damageCasesWorkflowPut(caseId: string, body: UpdateWorkflowRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/damage-cases/{caseId}/workflow";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDamageCasesWorkflowPut(_response);
        });
    }

    protected processDamageCasesWorkflowPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Invalid document ids", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Case or workflow not found", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Case is not InProgress", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Upload a workflow document for a damage case
     * @param file (optional) 
     * @return Document uploaded
     */
    damageCasesWorkflowDocumentsPost(caseId: string, file: FileParameter | undefined): Promise<WorkflowDocumentRef> {
        let url_ = this.baseUrl + "/damage-cases/{caseId}/workflow/documents";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDamageCasesWorkflowDocumentsPost(_response);
        });
    }

    protected processDamageCasesWorkflowDocumentsPost(response: Response): Promise<WorkflowDocumentRef> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkflowDocumentRef;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("HEIC/HEIF conversion failed", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Case not found or workflow not started", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Case is not InProgress", status, _responseText, _headers);
            });
        } else if (status === 413) {
            return response.text().then((_responseText) => {
            return throwException("Request exceeds the upload size limit", status, _responseText, _headers);
            });
        } else if (status === 415) {
            return response.text().then((_responseText) => {
            return throwException("Unsupported file type", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkflowDocumentRef>(null as any);
    }

    /**
     * Delete a workflow document from a damage case
     * @return Deleted
     */
    damageCasesWorkflowDocumentsDelete(caseId: string, documentId: string): Promise<void> {
        let url_ = this.baseUrl + "/damage-cases/{caseId}/workflow/documents/{documentId}";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDamageCasesWorkflowDocumentsDelete(_response);
        });
    }

    protected processDamageCasesWorkflowDocumentsDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Case not found or workflow not started", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("Case is not InProgress", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Download workflow document content
     * @return Success
     */
    damageCasesWorkflowDocumentsContent(caseId: string, documentId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/damage-cases/{caseId}/workflow/documents/{documentId}/content";
        if (caseId === undefined || caseId === null)
            throw new globalThis.Error("The parameter 'caseId' must be defined.");
        url_ = url_.replace("{caseId}", encodeURIComponent("" + caseId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDamageCasesWorkflowDocumentsContent(_response);
        });
    }

    protected processDamageCasesWorkflowDocumentsContent(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Upload a damage photo
     * @param file (optional) 
     * @return Photo uploaded
     */
    damagePhotosPost(file: FileParameter | undefined): Promise<UploadDamagePhotoResponse> {
        let url_ = this.baseUrl + "/damage-photos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDamagePhotosPost(_response);
        });
    }

    protected processDamagePhotosPost(response: Response): Promise<UploadDamagePhotoResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UploadDamagePhotoResponse;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Validation failed (FileNameMismatch, EmptyFile, HeicConversionFailed)", status, _responseText, _headers);
            });
        } else if (status === 413) {
            return response.text().then((_responseText) => {
            return throwException("Request exceeds the upload size limit", status, _responseText, _headers);
            });
        } else if (status === 415) {
            return response.text().then((_responseText) => {
            return throwException("File type not supported", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UploadDamagePhotoResponse>(null as any);
    }

    /**
     * Get metadata for damage photos by ids
     * @param ids (optional) 
     * @return Metadata list
     */
    damagePhotosGet(ids: string[] | undefined): Promise<AttachmentMetadataResponse[]> {
        let url_ = this.baseUrl + "/damage-photos?";
        if (ids === null)
            throw new globalThis.Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDamagePhotosGet(_response);
        });
    }

    protected processDamagePhotosGet(response: Response): Promise<AttachmentMetadataResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AttachmentMetadataResponse[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttachmentMetadataResponse[]>(null as any);
    }

    /**
     * Download damage photo content
     * @return Success
     */
    damagePhotosContent(id: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/damage-photos/{id}/content";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDamagePhotosContent(_response);
        });
    }

    protected processDamagePhotosContent(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Delete a damage photo
     * @return Photo deleted
     */
    damagePhotosDelete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/damage-photos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDamagePhotosDelete(_response);
        });
    }

    protected processDamagePhotosDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Photo not found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Advanced person search
     * @param whoIsWho (optional) 
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param activeOnly (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return Matching persons
     */
    personsSearchExternal(whoIsWho: string | undefined, firstName: string | undefined, lastName: string | undefined, activeOnly: boolean | undefined, page: number | undefined, pageSize: number | undefined): Promise<PersonSearchResponse> {
        let url_ = this.baseUrl + "/persons/search-external?";
        if (whoIsWho === null)
            throw new globalThis.Error("The parameter 'whoIsWho' cannot be null.");
        else if (whoIsWho !== undefined)
            url_ += "whoIsWho=" + encodeURIComponent("" + whoIsWho) + "&";
        if (firstName === null)
            throw new globalThis.Error("The parameter 'firstName' cannot be null.");
        else if (firstName !== undefined)
            url_ += "firstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName === null)
            throw new globalThis.Error("The parameter 'lastName' cannot be null.");
        else if (lastName !== undefined)
            url_ += "lastName=" + encodeURIComponent("" + lastName) + "&";
        if (activeOnly === null)
            throw new globalThis.Error("The parameter 'activeOnly' cannot be null.");
        else if (activeOnly !== undefined)
            url_ += "activeOnly=" + encodeURIComponent("" + activeOnly) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPersonsSearchExternal(_response);
        });
    }

    protected processPersonsSearchExternal(response: Response): Promise<PersonSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonSearchResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonSearchResponse>(null as any);
    }

    /**
     * Get damage types
     * @return List of damage types
     */
    referenceDataDamageTypes(): Promise<string[]> {
        let url_ = this.baseUrl + "/reference-data/damage-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReferenceDataDamageTypes(_response);
        });
    }

    protected processReferenceDataDamageTypes(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    systemPing(): Promise<Ping> {
        let url_ = this.baseUrl + "/_system/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSystemPing(_response);
        });
    }

    protected processSystemPing(response: Response): Promise<Ping> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Ping;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ping>(null as any);
    }

    /**
     * @return Success
     */
    systemAuth(): Promise<AuthState> {
        let url_ = this.baseUrl + "/_system/auth";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSystemAuth(_response);
        });
    }

    protected processSystemAuth(response: Response): Promise<AuthState> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AuthState;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthState>(null as any);
    }
}

export enum CaseStatus {
    Created = "Created",
    InProgress = "InProgress",
    Closed = "Closed",
}

export enum CaseType {
    Damage = "Damage",
    Accident = "Accident",
}

export enum DamageType {
    AccidentalDamage = "AccidentalDamage",
    BigDent = "BigDent",
    Cracking = "Cracking",
    DamagedChromeStrip = "DamagedChromeStrip",
    DamagedRim = "DamagedRim",
    DamagedTire = "DamagedTire",
    DentAndPaintDamage = "DentAndPaintDamage",
    HailDamage = "HailDamage",
    LargeScratch = "LargeScratch",
    PaintDamage = "PaintDamage",
    PartIsDamaged = "PartIsDamaged",
    PartIsMissing = "PartIsMissing",
    ProfileDepth = "ProfileDepth",
    Rockfall = "Rockfall",
    SmallDent = "SmallDent",
    SmallScratch = "SmallScratch",
}

export enum PaymentStatus {
    Open = "Open",
    Paid = "Paid",
    Disputed = "Disputed",
}

export enum RepairStatus {
    Pending = "Pending",
    InProgress = "InProgress",
    Completed = "Completed",
    Cancelled = "Cancelled",
}

export enum SourceSystem {
    FLIMS = "FLIMS",
    QDC = "QDC",
    KEMAS = "KEMAS",
    FF = "FF",
    DamageDoc = "DamageDoc",
}

export enum VehicleType {
    Sedan = "Sedan",
    Suv = "Suv",
    OffRoad = "OffRoad",
    Van = "Van",
    Wagon = "Wagon",
}

export enum WhoWasAtFault {
    ThirdPartyAtFault = "ThirdPartyAtFault",
    HitAndRun = "HitAndRun",
    OwnFault = "OwnFault",
    Unclear = "Unclear",
    SharedFault = "SharedFault",
}

export enum ExportScope {
    CaseDetails = "CaseDetails",
    CaseWorkflow = "CaseWorkflow",
    CaseDetailsAndWorkflow = "CaseDetailsAndWorkflow",
}

export interface AccidentCaseResponse {
    damageGeneralData?: DamageGeneralData;
    police?: Police;
    driverPersonalData?: DriverPersonalData;
    ownVehicle?: OwnVehicle;
    damageMarking?: DamageMarking;
    otherParty?: OtherParty;
    caseDescription?: CaseDescription;
    internal?: InternalData;
    caseSubmissionId?: string | undefined;
}

export interface AttachmentMetadataResponse {
    id?: string;
    fileName?: string | undefined;
    contentType?: string | undefined;
    sizeBytes?: number;
}

export interface AuthState {
    userKey?: string | undefined;
    securityTokens?: string[] | undefined;
}

export interface CaseDescription {
    description?: string | undefined;
    sketchIds?: string[] | undefined;
}

export interface CaseSubmissionExpiredResponse {
    id?: string;
    expiredAt?: dayjs.Dayjs;
    sourceSystem?: SourceSystem;
}

export interface CaseSubmissionResponse {
    id?: string;
    sourceSystem?: SourceSystem;
    vehicleMandant?: string | undefined;
    driverName?: string | undefined;
    driverWhoIsWho?: string | undefined;
    isExternalDriver?: boolean;
    driverAdditionalInfo?: string | undefined;
    tripNumber?: string | undefined;
    tripPurpose?: string | undefined;
    licensePlate?: string | undefined;
    vehicleModel?: string | undefined;
    embossedId?: string | undefined;
    vehicleResponsibleName?: string | undefined;
    vehicleResponsibleWhoIsWho?: string | undefined;
    caseCreatorName?: string | undefined;
    caseCreatorWhoIsWho?: string | undefined;
    expiresAt?: dayjs.Dayjs | undefined;
}

export interface CaseListItem {
    id?: string;
    caseNumber?: string | undefined;
    type?: CaseType;
    licensePlate?: string | undefined;
    embossedId?: string | undefined;
    date?: dayjs.Dayjs;
    location?: string | undefined;
    driver?: string | undefined;
    status?: CaseStatus;
}

export interface CaseListResponse {
    items?: CaseListItem[] | undefined;
    totalCount?: number;
    page?: number;
    pageSize?: number;
}

export interface CaseMetaResponse {
    id?: string;
    type?: CaseType;
    caseNumber?: string | undefined;
    status?: CaseStatus;
    licensePlate?: string | undefined;
    driverName?: string | undefined;
}

export interface ConvertCaseResponse {
    id?: string;
}

export interface CreateAccidentCaseRequest {
    damageGeneralData?: DamageGeneralData;
    police?: Police;
    driverPersonalData?: DriverPersonalData;
    ownVehicle?: OwnVehicle;
    damageMarking?: DamageMarking;
    otherParty?: OtherParty;
    caseDescription?: CaseDescription;
    internal?: InternalData;
    caseSubmissionId?: string | undefined;
}

export interface CreateCaseResponse {
    id?: string;
    caseNumber?: string | undefined;
}

export interface CreateDamageCaseRequest {
    damageGeneralData?: DamageGeneralData;
    driverPersonalData?: DriverPersonalData;
    ownVehicle?: OwnVehicle;
    damageMarking?: DamageMarking;
    caseDescription?: CaseDescription;
    internal?: InternalData;
    caseSubmissionId?: string | undefined;
}

export interface DamageCaseResponse {
    damageGeneralData?: DamageGeneralData;
    driverPersonalData?: DriverPersonalData;
    ownVehicle?: OwnVehicle;
    damageMarking?: DamageMarking;
    caseDescription?: CaseDescription;
    internal?: InternalData;
    caseSubmissionId?: string | undefined;
}

export interface DamageGeneralData {
    dateTimeOfDamage?: dayjs.Dayjs;
    location?: string | undefined;
    country?: string | undefined;
}

export interface DamageMarkerEntry {
    id?: string | undefined;
    orderNumber?: number;
    positionX?: number;
    positionY?: number;
    damageType?: DamageType;
}

export interface DamageMarking {
    id?: string | undefined;
    description?: string | undefined;
    vehicleType?: VehicleType;
    markerAreaWidth?: number;
    markerAreaHeight?: number;
    markers?: DamageMarkerEntry[] | undefined;
    photoIds?: string[] | undefined;
}

export interface DriverPersonalData {
    driverName?: string | undefined;
    driverWhoIsWho?: string | undefined;
    isExternalDriver?: boolean;
    driverAdditionalInfo?: string | undefined;
    dateOfBirth?: dayjs.Dayjs | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    street?: string | undefined;
    houseNr?: string | undefined;
    mobile?: string | undefined;
}

export interface InternalData {
    sourceSystem?: SourceSystem;
    vehicleMandant?: string | undefined;
    vehicleResponsibleName?: string | undefined;
    vehicleResponsibleWhoIsWho?: string | undefined;
    caseCreatorName?: string | undefined;
    caseCreatorWhoIsWho?: string | undefined;
    tripNumber?: string | undefined;
    tripPurpose?: string | undefined;
    driverNotAuthorizedReason?: string | undefined;
    violationReason?: string | undefined;
}

export interface OtherParty {
    vehicle?: OtherPartyVehicle;
    damageMarking?: OtherPartyDamageMarking;
    insurance?: OtherPartyInsurance;
}

export interface OtherPartyDamageMarking {
    id?: string | undefined;
    description?: string | undefined;
    vehicleType?: VehicleType;
    markerAreaWidth?: number;
    markerAreaHeight?: number;
    markers?: DamageMarkerEntry[] | undefined;
    photoIds?: string[] | undefined;
}

export interface OtherPartyInsurance {
    insuranceCompany?: string | undefined;
    insuranceNumber?: string | undefined;
    opponentName?: string | undefined;
    opponentAddress?: string | undefined;
    opponentMobile?: string | undefined;
}

export interface OtherPartyVehicle {
    opponentLicensePlate?: string | undefined;
    opponentModel?: string | undefined;
    opponentManufacturer?: string | undefined;
}

export interface OwnVehicle {
    licensePlate?: string | undefined;
    vehicleModel?: string | undefined;
    mileage?: number;
    embossedId?: string | undefined;
}

export interface PersonResponse {
    whoIsWho?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: dayjs.Dayjs | undefined;
    mobile?: string | undefined;
}

export interface PersonSearchResponse {
    items?: PersonResponse[] | undefined;
    totalCount?: number;
    page?: number;
    pageSize?: number;
}

export interface Ping {
    utcNow?: dayjs.Dayjs;
}

export interface Police {
    caseOfficerName?: string | undefined;
    contactDetails?: string | undefined;
    policeStation?: string | undefined;
    caseNumber?: string | undefined;
    whoWasFined?: string | undefined;
}

export interface UpdateAccidentCaseRequest {
    damageGeneralData?: DamageGeneralData;
    police?: Police;
    driverPersonalData?: DriverPersonalData;
    ownVehicle?: OwnVehicle;
    damageMarking?: DamageMarking;
    otherParty?: OtherParty;
    caseDescription?: CaseDescription;
    internal?: InternalData;
    caseSubmissionId?: string | undefined;
}

export interface UpdateDamageCaseRequest {
    damageGeneralData?: DamageGeneralData;
    driverPersonalData?: DriverPersonalData;
    ownVehicle?: OwnVehicle;
    damageMarking?: DamageMarking;
    caseDescription?: CaseDescription;
    internal?: InternalData;
    caseSubmissionId?: string | undefined;
}

export interface UploadDamagePhotoResponse {
    id?: string;
    fileName?: string | undefined;
    contentType?: string | undefined;
    sizeBytes?: number;
}

export interface UploadDamageSketchResponse {
    id?: string;
    fileName?: string | undefined;
    contentType?: string | undefined;
    sizeBytes?: number;
}

export interface UpdateWorkflowRequest {
    fields?: WorkflowData;
    documentIds?: string[] | undefined;
}

export interface WorkflowData {
    dateOfDamage?: dayjs.Dayjs | undefined;
    reportedToInsurance?: dayjs.Dayjs | undefined;
    claimNumber?: string | undefined;
    internalNumber?: string | undefined;
    policeFileNumber?: string | undefined;
    whoWasAtFault?: WhoWasAtFault;
    appraisalDate?: dayjs.Dayjs | undefined;
    appraisalNumber?: string | undefined;
    appraisalAmount?: number | undefined;
    appraisalDecision?: string | undefined;
    notifiedClaimsTeam?: dayjs.Dayjs | undefined;
    feedbackDecision?: string | undefined;
    smaContactPerson?: string | undefined;
    smaReferenceNr?: string | undefined;
    deliveryToBranch?: dayjs.Dayjs | undefined;
    returnFromWorkshop?: dayjs.Dayjs | undefined;
    repairStatus?: RepairStatus;
    repairNotes?: string | undefined;
    invoiceSent?: dayjs.Dayjs | undefined;
    invoiceAmount?: number | undefined;
    branchInvoiceNr?: string | undefined;
    paymentStatus?: PaymentStatus;
    flimsEntry?: dayjs.Dayjs | undefined;
    diversEntry?: dayjs.Dayjs | undefined;
    editorProcessor?: string | undefined;
    notes?: string | undefined;
}

export interface WorkflowDocumentRef {
    id?: string;
    fileName?: string | undefined;
    contentType?: string | undefined;
}

export interface WorkflowResponse {
    fields?: WorkflowData;
    documents?: WorkflowDocumentRef[] | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}